import { IconButton } from '@lbcamden/lib-react';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { FunctionComponent, PropsWithChildren, useCallback, useState } from 'react';

import { SensitiveValueWrapper } from './SensitiveValue.styled';

type Props = PropsWithChildren<{ label?: string; isBlank?: boolean }>;

export const SensitiveValue: FunctionComponent<Props> = ({ label, isBlank, children }) => {
  const [maskedState, setMaskedState] = useState(true);

  const handleToggle = useCallback(() => setMaskedState((x) => !x), []);
  const masked = maskedState && !isBlank;
  const valueLabel = label || 'data';

  return (
    <SensitiveValueWrapper>
      <span>{masked ? <span aria-hidden>•••••••••</span> : children}</span>
      {masked && <VisuallyHidden>Sensitive data hidden</VisuallyHidden>}

      {!isBlank && (
        <IconButton
          icon={maskedState ? 'ui/view' : 'ui/hide'}
          onClick={handleToggle}
          aria-label={maskedState ? `Reveal ${valueLabel}` : `Hide ${valueLabel}`}
        />
      )}
    </SensitiveValueWrapper>
  );
};
